import type { PrimaryColor } from "@/styles/theme/types";
import type { AppDirection } from "@/types/settings";

// Shape matches every other Scouting Ops app's AppConfig (hub, calendar,
// community, docs, sign-ups) — see each repo's src/config/app.ts.
export interface AppConfig {
  name: string;
  description: string;
  direction: AppDirection;
  language: string;
  theme: "light" | "dark" | "system";
  themeColor: string;
  primaryColor: PrimaryColor;
}

export const appConfig: AppConfig = {
  name: "Scouting Ops Site",
  description: "Build and publish your unit's public website — no coding required.",
  direction: "ltr",
  language: "en-US",
  theme: "dark",
  themeColor: "#050505",
  primaryColor: "scoutingGreen",
};
